function PlusIcon() {
  return (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeWidth={2.5} d="M12 5v14M5 12h14" />
    </svg>
  );
}

function MinusIcon() {
  return (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeWidth={2.5} d="M5 12h14" />
    </svg>
  );
}

interface QuantityStepperProps {
  quantity: number;
  onIncrease: () => void;
  onDecrease: () => void;
  disableIncrease?: boolean;
  disableDecrease?: boolean;
  max?: number;
  size?: 'md' | 'lg';
  className?: string;
}

const BUTTON_SIZE_CLASS = {
  md: 'w-8 h-8',
  lg: 'w-11 h-11',
};

const BUTTON_BASE_CLASS =
  'flex items-center justify-center rounded-full text-text-dark disabled:opacity-30 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-chocolate focus-visible:ring-offset-2';

export function QuantityStepper({
  quantity,
  onIncrease,
  onDecrease,
  disableIncrease = false,
  disableDecrease = false,
  max,
  size = 'md',
  className = '',
}: QuantityStepperProps) {
  const increaseDisabled = disableIncrease || (max !== undefined && quantity >= max);
  const buttonClass = `${BUTTON_BASE_CLASS} ${BUTTON_SIZE_CLASS[size]}`;

  return (
    <div className={`inline-flex items-center border-[1.5px] border-champagne-dark rounded-full ${className}`}>
      <button
        type="button"
        onClick={onDecrease}
        disabled={disableDecrease}
        aria-label="Diminuir quantidade"
        className={buttonClass}
      >
        <MinusIcon />
      </button>
      <span aria-live="polite" className="w-7 text-center text-sm font-bold text-text-dark">{quantity}</span>
      <button
        type="button"
        onClick={onIncrease}
        disabled={increaseDisabled}
        aria-label="Aumentar quantidade"
        className={buttonClass}
      >
        <PlusIcon />
      </button>
    </div>
  );
}
